import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { EventTypes } from 'src/app/core/constants/event-types';
import { BlackListsService } from '../../../../core/api/services/black-lists.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-black-list-form',
    templateUrl: './black-list-form.component.html',
    styles: [
        `
      fieldset {
        border: none !important;
      }
    `,
    ],
    imports: [BaseFormModule]
})
export class BlackListFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  mobileNumbers: string;
  protected currentService = inject(BlackListsService);
  constructor() {
    super();
  }

  ngOnInit() {
    try {
      this.getVocabs();
      this.initForm();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      blackList: new FormGroup({
        mobileNumbers: new FormControl('', Validators.required),
      }),
    });
  }

  get errorControl() {
    try {
      let validateBlackList = this.form.controls.blackList as FormGroup;
      return validateBlackList.controls;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
  //#region Api

  baseCreateApi(mobileNumbers: string) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .blackListsCreatePost({ body: { numbers: mobileNumbers } })
      .pipe(this.basePipeOperators())
      .subscribe((result) => {
        this.apiNotificationService.notifyMessage({ result });
        if (result.isSucceed) this.onSuccess();
      });
  }
  baseUpdateApi(model: any): void {}
  //#endregion

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      this.baseCreateApi(this.mobileNumbers);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
}
